module.exports = __webpack_public_path__ + "static/img/vrRoad_cover_2.a9244700.png";